// eslint-disable-next-line import/no-cycle
import {
  USER_GET_LIST,
  USER_GET_LIST_SUCCESS,
  USER_GET_LIST_ERROR,
  USER_CREATE,
  USER_CREATE_SUCCESS,
  USER_CREATE_ERROR,
  USER_GET_DETAIL,
  USER_GET_DETAIL_SUCCESS,
  USER_GET_DETAIL_ERROR,
  USER_UPDATE,
  USER_UPDATE_SUCCESS,
  USER_UPDATE_ERROR,
} from '../actions';

export const userGetList = (callback) => ({
  type: USER_GET_LIST,
  callback
})
export const userGetListSuccessed = (data) => ({
  type: USER_GET_LIST_SUCCESS,
  payload: data,
});
export const userGetListFailed = (error) => ({
  type: USER_GET_LIST_ERROR,
  payload: error
});

export const userCreate = (params, callback) => ({
  type: USER_CREATE,
  payload: { params },
  callback,
})
export const userCreateSuccessed = (data) => ({
  type: USER_CREATE_SUCCESS,
  payload: data,
});
export const userCreateFailed = (error) => ({
  type: USER_CREATE_ERROR,
  payload: error
});

export const userGetDetail = (user_id, callback) => ({
  type: USER_GET_DETAIL,
  payload: { user_id },
  callback,
});
export const userGetDetailSuccessed = (data) => ({
  type: USER_GET_DETAIL_SUCCESS,
  payload: data,
});
export const userGetDetailFailed = (message) => ({
  type: USER_GET_DETAIL_ERROR,
  payload: { message },
});

export const userUpdate = (id, params, callback) => ({
  type: USER_UPDATE,
  payload: { id, params },
  callback,
})
export const userUpdateSuccessed = (data) => ({
  type: USER_UPDATE_SUCCESS,
  payload: data,
});
export const userUpdateFailed = (error) => ({
  type: USER_UPDATE_ERROR,
  payload: error
});